/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Predictions API
 * API documentation for Predictions
 * OpenAPI spec version: 1.24.0
 */

export type PlaeePositionResponseDtoStatus =
  (typeof PlaeePositionResponseDtoStatus)[keyof typeof PlaeePositionResponseDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PlaeePositionResponseDtoStatus = {
  OPEN: 'OPEN',
  CLOSED: 'CLOSED',
  SETTLED: 'SETTLED',
} as const;
